import {
  ABHA_AADHAAR_SEND_OTP_ENDPOINT,
  ABHA_AADHAAR_VERIFY_OTP_ENDPOINT,
  ABHA_MOCK_OTP,
  USE_MOCK_ABHA_OTP,
} from '@constants/abha.constants'
import { sanitizeAadhaar } from '@helpers/abhaWidgetHelper'

export type AbhaOtpRequestPayload = {
  phone: string
  aadhaar: string
}

export type AbhaOtpVerifyPayload = AbhaOtpRequestPayload & {
  otp: string
}

export const sendAbhaAadhaarOtp = async ({ phone, aadhaar }: AbhaOtpRequestPayload) => {
  if (USE_MOCK_ABHA_OTP) {
    return await Promise.resolve({})
  }

  const response = await fetch(ABHA_AADHAAR_SEND_OTP_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone,
      aadhaar: sanitizeAadhaar(aadhaar),
    }),
  })

  if (!response.ok) {
    throw new Error('Unable to send OTP. Please try again.')
  }

  return await response.json().catch(() => ({}))
}

export const verifyAbhaAadhaarOtp = async ({ phone, aadhaar, otp }: AbhaOtpVerifyPayload) => {
  if (USE_MOCK_ABHA_OTP) {
    if (otp !== ABHA_MOCK_OTP) {
      throw new Error('Invalid OTP. Please try again.')
    }

    return await Promise.resolve({})
  }

  const response = await fetch(ABHA_AADHAAR_VERIFY_OTP_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone,
      aadhaar: sanitizeAadhaar(aadhaar),
      otp,
    }),
  })

  if (!response.ok) {
    throw new Error('Invalid OTP. Please try again.')
  }

  return await response.json().catch(() => ({}))
}
